
import { register } from 'register-service-worker'
register(`${process.env.BASE_URL}service-worker.js`, {
  ready () {
  },
  registered () {
  },
  cached () {
  },
  updatefound () {
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => {
        caches.delete(cacheName)
      })
    })
  },
  updated () {
  },
  offline () {
  },
  error (error) {
    console.error('Error during service worker registration:', error)
  }
})
